import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import _ from 'underscore';
import { ViewSuggestionType, maxHeadlineCount, maxDescriptionCount } from './ad-strength-helper';
import { AdStrengthSuggestionRepository } from './rsa-ad-strength-suggestion-repository';
import { updateAdStrengthSuggestion,
  containerExists,
  renderContainer,
  viewSuggestionMeasurement,
  applySuggestionMeasurement,
  returnSuggestionMeasurement,
  isViewSuggestionApplied,
  renderNoSuggestion } from './rsa-ad-strength-suggestion-helper';

let currentFinalUrl = '';

const TIPS_CATEGORIES = [
  { name: 'Product', numItems: 4 },
  { name: 'Benefits', numItems: 4 },
  { name: 'Brand', numItems: 4 },
  { name: 'Action', numItems: 4 },
  { name: 'Inventory', numItems: 4 },
  { name: 'Pricing', numItems: 4 },
  { name: 'Promotion', numItems: 4 },
];

const manageVisiblity = (e, targetContainer, expandingIcon) => {
  const target = $(e.target);
  const detailContainer = target.parent().parent().find(targetContainer);
  const expendingContainer = target.parent().parent().find(expandingIcon);
  const isDetailSuggestionVisible = detailContainer.is(':visible');
  // Hide all tips items
  $(targetContainer).hide();
  // Change all expending icon to expander
  $(expandingIcon).removeClass('expandedImage');
  $(expandingIcon).addClass('expanderImage');

  if (isDetailSuggestionVisible) {
    detailContainer.hide();
    return false;
  }
  detailContainer.show();
  expendingContainer.removeClass('expanderImage');
  expendingContainer.addClass('expandedImage');
  return true;
};

const viewHeadlineSuggestionTipCategoryItems = (category, i18n, e) => {
  manageVisiblity(e, '.ad-strength-suggestion-detail-tips-item-container', '.ad-strength-suggestion-detail-tips-expending');
  const target = $(e.target);
  const container = target.parent().parent().find('.ad-strength-suggestion-detail-tips-item-container');
  const items = _.map(_.range(1, category.numItems + 1), num => (
    <div className="ad-strength-suggestion-detail-tips-item">{i18n.getString(`Ad_Strength_Suggestion_Tips_Category_${category.name}_Item${num}`)}</div>
  ));
  const itemsWithSubtitle = (
    <div>
      <div className="ad-strength-suggestion-detail-tips-subtitle">{i18n.getString(`Ad_Strength_Suggestion_Tips_Category_${category.name}_Subtitle`)}</div>
      {items}
    </div>
  );
  renderContainer(itemsWithSubtitle, container);
};

const viewHeadlineSuggestionTips = (i18n) => {
  const categoryItems = _.map(TIPS_CATEGORIES, category => (
    <div className="ad-strength-suggestion-detail-tips-category">
      <span
        className="ad-strength-suggestion-detail-tips-title"
        aria-label={i18n.getString(`Ad_Strength_Suggestion_Tips_Category_${category.name}_Title`)}
        role="button"
        tabIndex="0"
        onClick={e => viewHeadlineSuggestionTipCategoryItems(category, i18n, e)}
        onKeyPress={e => viewHeadlineSuggestionTipCategoryItems(category, i18n, e)}
      >
        <span className="ad-strength-suggestion-detail-tips-expending expanderImage" />
        <div className="ad-strength-suggestion-detail-tips-category-title">{i18n.getString(`Ad_Strength_Suggestion_Tips_Category_${category.name}_Title`)}</div>
      </span>
      <div className="ad-strength-suggestion-detail-tips-item-container" />
    </div>
  ));
  const tips = (
    <div className="ad-strength-suggestion-detail-tips-container">
      <div className="ad-strength-suggestion-detail-tips-header">{i18n.getString('Ad_Strength_Suggestion_Tips_Header')}</div>
      <div className="ad-strength-suggestion-detail-tips-header-desc">{i18n.getString('Ad_Strength_Suggestion_Tips_Header_Desc')}</div>
      {categoryItems}
    </div>
  );
  return tips;
};

const addAssetSuggestion = (assetType, viewModel, e) => {
  let target = $(e.target);
  if (_.first(target).className === `ad-strength-suggestion-detail-suggestion-add-symbol ${assetType}`
  || _.first(target).className === `ad-strength-suggestion-detail-suggestion-content ${assetType}`) {
    target = target.parent();
  }
  if (_.first(target).className === `ad-strength-suggestion-detail-suggestion-disabled ${assetType}`) {
    return;
  }
  const content = _.first(target.find(`.ad-strength-suggestion-detail-suggestion-content.${assetType}`));
  if (_.isEmpty(content)) {
    return;
  }
  const suggestionId = _.first(target.find(`.ad-strength-suggestion-detail-suggestion-id.${assetType}`));
  if (!_.isEmpty(suggestionId)) {
    applySuggestionMeasurement(viewModel, suggestionId.textContent);
  }
  const suggestionToAdd = content.textContent;
  if (assetType === ViewSuggestionType.Headline) {
    const index = _.findIndex(_.range(viewModel.showHeadlineCount()), i =>
      _.isEmpty(`${viewModel[`Headline${i}`]()}`));
    if (index !== -1) {
      viewModel[`Headline${index}`](suggestionToAdd);
    } else if (viewModel.showHeadlineCount() < maxHeadlineCount) {
      viewModel.showHeadlineCount(viewModel.showHeadlineCount() + 1);
      viewModel[`Headline${viewModel.showHeadlineCount() - 1}`](suggestionToAdd);
    }
  } else if (assetType === ViewSuggestionType.Description) {
    const index = _.findIndex(_.range(viewModel.showDescriptionCount()), i =>
      _.isEmpty(`${viewModel[`Description${i}`]()}`));
    if (index !== -1) {
      viewModel[`Description${index}`](suggestionToAdd);
    } else if (viewModel.showDescriptionCount() < maxDescriptionCount) {
      viewModel.showDescriptionCount(viewModel.showDescriptionCount() + 1);
      viewModel[`Description${viewModel.showDescriptionCount() - 1}`](suggestionToAdd);
    }
  }
};


const renderSuggestionContent = (
  container,
  content,
  repository,
  i18n,
  assetType,
  viewModel,
  isForVNext
) => {
  // Show suggestion
  _.first(container).style.display = 'block';

  // Render suggestion static content in advance
  renderContainer(content, container);

  if (currentFinalUrl === _.first(viewModel.FinalUrls())) {
    return;
  }

  currentFinalUrl = _.first(viewModel.FinalUrls());

  // Get suggestion from AdInsight MT
  repository.fetchAdStrengthSuggestion().then(({ data }) => {
    currentFinalUrl = '';

    const suggestionContainers = container.find(`.ad-strength-suggestion-detail-suggestions-container.${assetType}`);
    const noSuggestionContainers = container.find(`.ad-strength-suggestion-detail-nosuggestion-container.${assetType}`);
    // Empty suggestions
    renderContainer([], suggestionContainers);

    if (!_.isEmpty(data)) {
      const {
        ErrorCode,
        RSAV2AssetsSuggestions,
      } = data;
      if (ErrorCode !== 'Success' || _.isEmpty(RSAV2AssetsSuggestions)) {
        renderNoSuggestion(noSuggestionContainers, i18n);
      } else {
        const allSuggestions = _.first(RSAV2AssetsSuggestions).Suggestions;
        const suggestions = _.filter(allSuggestions, suggestion =>
          suggestion.AssetType.toLowerCase() === assetType && !_.isEmpty(suggestion.Asset));
        const viewSuggestionIds = [];
        const returnSuggestionIds = [];
        const items = _.map(suggestions, (suggestion) => {
          returnSuggestionIds.push(suggestion.SuggestionId);
          const suggestionAssetType = suggestion.AssetType.toLowerCase();
          const suggestionClassName = `ad-strength-suggestion-detail-suggestion ${suggestionAssetType}`;
          const addSymbolClassName = `ad-strength-suggestion-detail-suggestion-add-symbol ${suggestionAssetType}`;
          const idClassName = `ad-strength-suggestion-detail-suggestion-id ${suggestionAssetType}`;
          const contentClassName = `ad-strength-suggestion-detail-suggestion-content ${suggestionAssetType}`;
          if (!isViewSuggestionApplied(viewModel, assetType, suggestion.Asset)) {
            viewSuggestionIds.push(suggestion.SuggestionId);
          }
          return (
            <div
              className={suggestionClassName}
              role="button"
              tabIndex="0"
              onClick={e => addAssetSuggestion(assetType, viewModel, e)}
              onKeyPress={e => addAssetSuggestion(assetType, viewModel, e)}
            >
              <div className={addSymbolClassName}>+</div>
              <div className={idClassName}>{suggestion.SuggestionId}</div>
              <div className={contentClassName}>{suggestion.Asset}</div>
            </div>);
        });

        viewSuggestionMeasurement(viewModel, viewSuggestionIds);
        returnSuggestionMeasurement(viewModel, returnSuggestionIds);
        if (!_.isEmpty(items) && containerExists(suggestionContainers)) {
          let suggestionContent = [];
          const header = (
            <div className="ad-strength-suggestion-detail-sub-title">
              { assetType === ViewSuggestionType.Headline ?
                i18n.getString('Ad_Strength_Suggestion_HeadlineSuggestions_Subtitle') :
                i18n.getString('Ad_Strength_Suggestion_DescriptionSuggestions_Subtitle')
              }
            </div>);
          const noAvailableNewAssetContentClassName = `ad-strength-suggestion-detail-no-new-asset-content ${assetType}`;
          const noAvailableNewAssetContainerClassName = `alert alert-info form-group ad-strength-suggestion-detail-no-new-asset-container ${assetType}`;
          const noAvailableNewAsset = (
            <div className={noAvailableNewAssetContainerClassName}>
              <div className="alert-image" />
              <div className={noAvailableNewAssetContentClassName} />
            </div>);
          suggestionContent.push(header);
          suggestionContent.push(noAvailableNewAsset);
          suggestionContent = suggestionContent.concat(items);
          renderContainer(suggestionContent, suggestionContainers);
          updateAdStrengthSuggestion(i18n, viewModel);
        } else {
          renderNoSuggestion(noSuggestionContainers, i18n);
        }
      }
    } else if (_.isEmpty(viewModel.FinalUrls())) {
      const warningIconClassName = isForVNext ?
        'status-icon iconba iconba-Warning' :
        'status_warning status ad-strength-suggestion-detail-warning';
      const warningIconStyle = isForVNext ?
        { paddingRight: '5px', color: 'red' } :
        { paddingRight: '5px' };
      const noFinalUrl = (
        <div>
          <span className={warningIconClassName} style={warningIconStyle} />
          {i18n.getString('Ad_Strength_Suggestion_NoSuggestion_Add_Final_URL')}
        </div>
      );
      // Add a final URL to see more recommendations.
      renderContainer(noFinalUrl, noSuggestionContainers);
    } else {
      renderNoSuggestion(noSuggestionContainers, i18n);
    }
  });
};

const hideAdStrengthSuggestionContainer = () => {
  const container = $('.ad-strength-suggestions-detail');
  if (containerExists(container)) {
    _.first(container).style.display = 'none';
  }
};

export const viewInlineSuggestion = (
  i18n,
  viewModel,
  repository,
  assetType,
  action,
  isForVNext
) => {
  const suggestionContanerClassName = `ad-strength-suggestion-detail-suggestions-container ${assetType}`;
  const noSuggestionContainerClassName = `ad-strength-suggestion-detail-nosuggestion-container ${assetType}`;
  const currentActionClasName = 'ad-strength-suggestion-current-action';

  let combinedClickViewIdeas = viewModel.clickViewIdeas || [];
  combinedClickViewIdeas = combinedClickViewIdeas.concat([action]);
  // eslint-disable-next-line no-param-reassign
  viewModel.clickViewIdeas = _.uniq(combinedClickViewIdeas);

  let title = assetType === ViewSuggestionType.Headline ?
    i18n.getString('Ad_Strength_Suggestion_HeadlineSuggestions') :
    i18n.getString('Ad_Strength_Suggestion_DescriptionSuggestions');
  switch (action) {
    case 'LongerHeadlines':
      title = i18n.getString('Ad_Strength_Suggestion_HeadlineSuggestions_LongerHeadlines');
      break;
    case 'LongerDescriptions':
      title = i18n.getString('Ad_Strength_Suggestion_DescriptionSuggestions_LongerDescriptions');
      break;
    case 'DistinctHeadlines':
      title = i18n.getString('Ad_Strength_Suggestion_HeadlineSuggestions_DistinctHeadlines');
      break;
    case 'DistinctDescriptions':
      title = i18n.getString('Ad_Strength_Suggestion_DescriptionSuggestions_DistinctDescriptions');
      break;
    default:
      break;
  }
  const content = (
    <div>
      <span
        className="closeimage ad-strength-suggestions-detail-close-button"
        role="button"
        tabIndex="0"
        aria-label={i18n.getString('Ad_Strength_Suggestion_Close')}
        onClick={() => hideAdStrengthSuggestionContainer()}
        onKeyPress={() => hideAdStrengthSuggestionContainer()}
      />
      <div className="ad-strength-suggestion-detail-title">
        { title }
      </div>
      <div className={suggestionContanerClassName} />
      <div className={noSuggestionContainerClassName} />
      <div className={currentActionClasName} style={{ display: 'none' }}>{action}</div>
      { assetType === ViewSuggestionType.Headline ? viewHeadlineSuggestionTips(i18n) : null }
    </div>
  );
  const container = $('.ad-strength-suggestions-detail');
  if (containerExists(container)) {
    renderSuggestionContent(
      container,
      content,
      repository,
      i18n,
      assetType,
      viewModel,
      isForVNext
    );
  }
};

export const AdStrengthSuggestion = ({
  i18n,
  inlineSuggestionsEnabled,
  suggestion,
  viewModel,
  appState,
  token,
  odataPath,
  isForVNext,
}) => {
  const { action, suggestionType } = suggestion;
  const repository = new AdStrengthSuggestionRepository({
    viewModel,
    appState,
    token,
    odataPath,
  });

  if (!inlineSuggestionsEnabled || suggestionType === ViewSuggestionType.None) {
    return '';
  }

  return (
    <span
      className="ad-strength-suggestion-view"
      role="button"
      tabIndex="0"
      aria-label={i18n.getString('Ad_Strength_Suggestion_ViewSuggestions_Label', { suggestion: suggestion.suggestion })}
      onClick={() =>
        viewInlineSuggestion(i18n, viewModel, repository, suggestionType, action, isForVNext)}
      onKeyPress={() =>
        viewInlineSuggestion(i18n, viewModel, repository, suggestionType, action, isForVNext)}
    >
      <span>{i18n.getString('Ad_Strength_Suggestion_ViewSuggestions')}</span>
    </span>
  );
};

AdStrengthSuggestion.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  inlineSuggestionsEnabled: PropTypes.bool.isRequired,
  suggestion: PropTypes.shape({
    suggestion: PropTypes.string.isRequired,
    suggestionType: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
  }).isRequired,
  viewModel: PropTypes.objectOf(PropTypes.any).isRequired,
  appState: PropTypes.objectOf(PropTypes.any).isRequired,
  token: PropTypes.string.isRequired,
  odataPath: PropTypes.string.isRequired,
  isForVNext: PropTypes.bool.isRequired,
};
